import {Injectable, EventEmitter} from '@angular/core';
import {Http, Headers} from '@angular/http';
import {AppSettings} from '../models/AppSettings';
import {URLSearchParams} from "@angular/http";
import {Router} from '@angular/router';


@Injectable()
export class UserService {
    private loggedIn = false;
    private userChange: EventEmitter<boolean> = new EventEmitter();
    private loginUrl = 'login/';
    private loginRecupera = 'login/recupera';
    private loginReimposta = 'login/reimposta';
    private logoutUrl = 'logout/';
    private profilo: any;

    constructor(private http: Http, private router: Router) {
        this.loggedIn = !!localStorage.getItem('auth_token');
        if (this.loggedIn && !this.profilo) {
            //qua devo controllare
            this.controllaProfilo();
        }
    }

    cambiaLingua(lingua: any) {
        AppSettings.lingua = lingua.id;
        localStorage.setItem('lingua', lingua.id);
        let data = new URLSearchParams();
        data.append('token', localStorage.getItem('auth_token'));
        data.append('azione', 'check');
        return this.http.post(AppSettings.API_ENDPOINT + this.loginUrl, data).toPromise().then(rs => {
            let res = rs.json()
            this.risultato(res);
            if (!res.success) {
                this.nonAutorizzato();
            }
            this.userChange.emit(res.success);
            this.router.navigate(['home']);
            return res.success;
        });

    }

    controllaProfilo() {
        let data = new URLSearchParams();
        data.append('token', localStorage.getItem('auth_token'));
        data.append('azione', 'check');
        return this.http.post(AppSettings.API_ENDPOINT + this.loginUrl, data).toPromise().then(rs => {
            let res = rs.json()
            this.risultato(res);
            if (!res.success) {
                this.nonAutorizzato();
            }
            this.userChange.emit(res.success);
            return res.success;
        });
    }
    getProfilo(): any {
        return this.profilo;
    }

    getLoginEvent(): EventEmitter<boolean> {
        return this.userChange;
    }

    risultato(profilo: any) {
        if (profilo.success) {
            this.profilo = profilo;
            if (profilo["token"]) {//IL CONTROLLA NON MI RIDÀ IL TOKEN
                localStorage.setItem('auth_token', profilo["token"]);
            }
            if (profilo["traduzioni"]) {
                AppSettings.traduzioni = profilo["traduzioni"];
            }
            this.loggedIn = true;
        } else {

            this.loggedIn = false
        }


    }
    nonAutorizzato() {
        this.profilo = undefined;
        localStorage.removeItem('auth_token');
        this.loggedIn = false;
        this.userChange.emit(false);
        this.router.navigate(['/login']);
    }



    login(email, password) {
        let data = new URLSearchParams();
        data.append('uname', email);
        data.append('psw', password);
        localStorage.removeItem('auth_token');
        return this.http
            .post(AppSettings.API_ENDPOINT + this.loginUrl, data)
            .map(res => res.json())
            .map((res) => {
                this.risultato(res);

                /*if (res.success) {
                    localStorage.setItem('auth_token', res.token);
                    this.profilo = res;
                    this.loggedIn = true;
                } else {
                    this.loggedIn = false;
                }*/
                this.userChange.emit(this.isLoggedIn());

                return res;
            });
    }
    logout() {
        let token: string = localStorage.getItem('auth_token');
        let data = new URLSearchParams();
        data.append('token', token);
        if (AppSettings.traduzioniNuove) {
            data.append('traduzioni', JSON.stringify(AppSettings.traduzioniNuove));
        }
        localStorage.removeItem('auth_token');
        this.loggedIn = false;
        this.userChange.emit(false);
        this.http.post(AppSettings.API_ENDPOINT + this.logoutUrl, data).toPromise();
        AppSettings.traduzioniNuove = new Object();
    }

    isLoggedIn() {
        if (this.loggedIn && !this.profilo) {
            //qua devo controllare
            this.controllaProfilo();
        }
        return !!localStorage.getItem('auth_token');
    }

    /* GDPR */
    infoRecupera(): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.loginRecupera)
            .toPromise()
            .then(
            response => response.json()
            );
    }

    infoReimposta(): Promise<any> {
        return this.http.get(AppSettings.API_ENDPOINT + this.loginReimposta)
            .toPromise()
            .then(
            response => response.json()
            );
    }

    invioRecupera(email): Promise<any> {
        let data = new URLSearchParams();
        data.append('uname', email);
        data.append('azione', 'mail');
        return this.http
            .post(AppSettings.API_ENDPOINT + this.loginRecupera, data)
            .toPromise()
            .then(
            response => response.json()
            );
    }

    controlloReimposta(email, code): Promise<any> {
        let data = new URLSearchParams();
        data.append('uname', email);
        data.append('code', code);
        data.append('azione', 'reimposta');
        return this.http
            .post(AppSettings.API_ENDPOINT + this.loginReimposta, data)
            .toPromise()
            .then(
            response => response.json()
            );
    }
    nuovaPassword(email, code, psw, psw2): Promise<any> {
        let data = new URLSearchParams();
        data.append('uname', email);
        data.append('code', code);
        data.append('psw', psw);
        data.append('psw_confirm', psw2);
        data.append('azione', 'nuovaPassword');
        return this.http
            .post(AppSettings.API_ENDPOINT + this.loginReimposta, data)
            .toPromise()
            .then(
            response => response.json()
            );
    }

    nuovaPasswordAuth(email, auth, psw, psw2): Promise<any> {
        let data = new URLSearchParams();
        data.append('uname', email);
        data.append('auth', auth);
        data.append('psw', psw);
        data.append('psw_confirm', psw2);
        data.append('azione', 'nuovaPassword');
        return this.http
            .post(AppSettings.API_ENDPOINT + this.loginReimposta, data)
            .toPromise()
            .then(
            response => response.json()
            );
    }


}


// WEBPACK FOOTER //
// ./src/app/service/user.service.ts